import React, { useContext, useEffect } from "react";
import EngagementService from "./EngagementService";
import { SmartContext } from "../../../../library/Core/SmartContext";

const ProfileEngagement = () => {
  const { fetchEngagaementData } = EngagementService();
  const { state, dispatch } = useContext(SmartContext);

   useEffect(() => {
        const fetchData = async () => {
            try {
                const instituteId = state?.data?.selectedInstitute?.instituteId;
                const userEngagement = await fetchEngagaementData(state?.internal?.model?.id);
                console.log("userEngagement",userEngagement)

                // setEngagementData(userEngagement?.data?.[0] || null);

                dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: {
                       dataKey: 'engagementData',
                       value: userEngagement?.data?.reduce(
                                (max:any, item:any) => (item.id > max.id ? item : max),
                                userEngagement.data[0]
                            ) || null,
                    },
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

  const engagementData=state?.data?.engagementData;
  console.log("engagementData",state?.data?.engagementData)

  const identityData = {
      communication_style: {
        title: "Communication Style",
        value: engagementData?.communication_style,
        icon: "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-chat.svg",
      },
      decision_factor: {
        title: "Decision Factor",
        value: engagementData?.decision_factor,
        icon: "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-blub.svg",
      },
      peak_active_time: {
        title: "Peak Active Time",
        value: engagementData?.peak_active_time,
        icon: "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-history.svg",
      },
      triggers_hooks: {
        title: "Triggers & Hooks",
        value: engagementData?.triggers_hooks,
        icon: "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-hook.svg",
      },
    };

  const getPersonaImage = (ageBracket:any ,gender: any) => {
    // console.log(ageBracket,gender);
    if (ageBracket == '17-24' && gender == 'MALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-male-17-24.svg";
    }
    else if (ageBracket == '25-34' && gender == 'MALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-male-25-34.svg";
    }
    else if (ageBracket == '35-44' && gender == 'MALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-male-35-44.svg";
    }
    else if (ageBracket == '45-60' && gender == 'MALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-male-45-60.svg";
    }
    else if (ageBracket == '60+' && gender == 'MALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-male-60-plus.svg";
    }
    else if (ageBracket == '17-24' && gender == 'FEMALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-female-17-24.svg";
    }
    else if (ageBracket == '25-34' && gender == 'FEMALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-female-25-34.svg";
    }
    else if (ageBracket == '35-44' && gender == 'FEMALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-female-35-44.svg";
    }
    else if (ageBracket == '45-60' && gender == 'FEMALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-female-45-60.svg";
    }
    else if (ageBracket == '60+' && gender == 'FEMALE') {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-female-60-plus.svg";
    }
    else {
      return "https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-img.svg";
    }
  }
  
  return (
    <div
      className="tab-pane fade show active"
      id="pills-engagement"
      role="tabpanel"
      aria-labelledby="pills-engagement-activities-tab"
    >
      <div className="p-3 p-sm-4 p-md-4 mb-4 border-d2d2d2 border-radius-6">
        {engagementData && Object.keys(engagementData).length > 0 ? (
        <>
          <div className="row mb-4">
            <div className="col">
              <h2 className="font-36 font-600 mb-0">Persona</h2>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-7">
              <div className="row g-4">
                <div className="col-md-7">
                  <div className="persona-grd d-flex align-items-end px-3 px-sm-3 px-md-4">
                    <img
                      src={getPersonaImage(engagementData?.age_bracket, state?.data?.profile?.genderCode)}
                      alt=""
                    />
                    <div className="persona-grd-text d-flex flex-column justify-content-center align-items-start h-100 ps-3">
                      {engagementData?.age_bracket && (
                        <>
                          <h5 className="text-white mb-0">
                            {engagementData.age_bracket.match(/[\d\s\-+]+/)?.[0].trim() || engagementData.age_bracket}
                          </h5>
                          <p className="text-white mb-0">Years Old</p>
                        </>
                      )}
                    </div>

                  </div>
                </div>
                <div className="col-md-5">
                  <h5 className="font-20 font-600 d-flex align-items-center">
                    <img
                      src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/user-img-h5.svg"
                      className="me-2"
                      width="25"
                      alt=""
                    />
                    <span>Professional Identity</span>
                  </h5>
                  <p>{engagementData?.professional_identity} </p>
                </div>
              </div>
            </div>

          <div className="col-lg-5">
              <div className="row g-4">
                {Object.values(identityData).map((item, idx) => (
                  item.value && (
                    <div key={idx} className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
                      <div className="row g-3">
                        <div className="col-auto">
                          <img src={item.icon} width="34" alt={item.title} />
                        </div>
                        <div className="col">
                          <h3 className="font-18">{item.title}</h3>
                          <p className="text-gray-41">{item.value}</p>
                        </div>
                      </div>
                    </div>
                  )
                ))}
              </div>
            </div>

        <div className="col-md-12 pt-4">
            <div className="row g-4">
              {/* Engagement Prediction */}
              <div className="col-md-6">
                <div className="shadow p-5 h-100 border-radius-6">
                  <h3 className="font-30 font-600 mb-4">Engagement Prediction</h3>
                  <div className="row g-4">
                    {[
                      {
                        title: "Recruitment",
                        value: engagementData?.recruiter_score || 0,
                        description: engagementData?.recruitment_trigger.replace(/\s*\d+(\.\d+)?$/, "") || "",
                        label: "conversion probability",
                        linkText: "More Alumni"
                      },
                      {
                        title: "Mentorship",
                        value: engagementData?.mentorship_score || 0,
                        description: engagementData?.mentorship_trigger.replace(/\s*\d+(\.\d+)?$/, "") || "",
                        label: "conversion probability",
                        linkText: "More Alumni"
                      },
                      {
                        title: "Donations",
                        value: engagementData?.donor_score || 0,
                        description: engagementData?.donation_trigger.replace(/\s*\d+(\.\d+)?$/, "") || "",
                        label: "conversion probability",
                        linkText: "More Alumni"
                      }
                    ].map((item, index, array) => (
                      <React.Fragment key={index}>
                        <div className="col-12">
                          <h4 className="font-20 font-600 mb-0 text-dark-blue">{item.title}</h4>
                          <p className="font-16 font-500 mb-1 text-gray-41">{item.description}</p>
                          <div
                            className="progress mb-2 rounded-pill height-20"
                            role="progressbar"
                            aria-valuenow={item.value}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          >
                            <div
                              className="progress-bar rounded-pill position-relative bg-blue-0d3453"
                              style={{ width: `${item.value}%` }}
                            ></div>
                          </div>
                          <div className="row g-2">
                            <div className="col font-16 font-500 fst-italic text-gray-41">
                              {item.value}% {item.label}
                            </div>
                            {/* <div className="col-auto">
                              <a href="#" className="text-blue font-500">{item.linkText}</a>
                            </div> */}
                          </div>
                        </div>
                        {index !== array.length - 1 && (
                          <div className="col-12">
                            <hr />
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>

            {/* Most Engaged Topics */}
              <div className="col-md-6">
                <div className="shadow p-5 h-100 border-radius-6">
                  <h3 className="font-30 font-600 mb-4">Most Engaged Topics</h3>
                  <div className="row g-3">
                    {(engagementData?.top_5_topics || "")
                      .split(",")
                      .map((item:any) => {
                        const match = item.trim().match(/^(.+?)\s+(\d+)$/);
                        return match
                          ? {
                              label: match[1].trim(),
                              percent: parseInt(match[2].trim(), 10)
                            }
                          : null;
                      })
                      .filter(Boolean)
                      .slice(0, 5)
                      .map((item:any, index:any) => {
                        const colorClasses = [
                          { color: "bg-green-5bae47", className: "text-green-5bae47" },
                          { color: "bg-skyblue", className: "text-sky-blue" },
                          { color: "bg-purple", className: "text-purple" },
                          { color: "bg-yellow-f8b018", className: "text-yellow-f8b018" },
                          { color: "bg-red-d42941", className: "text-burgandi" }
                        ];
                        const { color, className } = colorClasses[index % colorClasses.length];
                        return (
                          <div key={index} className="col-12">
                            <h4 className={`font-18 font-600 mb-1 ${className}`}>{item.label}</h4>
                            <div
                              className="progress mb-2 rounded-pill height-28"
                              role="progressbar"
                              aria-valuenow={item.percent}
                              aria-valuemin={0}
                              aria-valuemax={100}
                            >
                              <div
                                className={`progress-bar rounded-pill position-relative ${color}`}
                                style={{ width: `${item.percent}%` }}
                              >
                                <b>{item.percent}%</b>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>

            </div>
          </div>


            {/* Best Time To Reach — hide entire block when value is missing */}
            {engagementData?.best_time_to_reach?.trim() ? (
            <div className="col-md-12 pt-4">
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <h5 className="d-flex justify-content-center align-items-center font-30 text-dark-blue">
                    <img
                      className="img-fluid me-2"
                      src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-time.svg"
                      width="63"
                      alt=""
                    />
                    Best Time To Reach
                  </h5>
                  <hr />
                  <p className="text-gray-41 font-500 text-center">
                  {engagementData.best_time_to_reach}
                  </p>
                </div>
              </div>
            </div>
            ) : null}
          </div>
        </>
          ) : (
            <div className="tab-pane fade show active" id="pills-engagement" role="tabpanel" aria-labelledby="pills-engagement-activities-tab">
                        
                        <div className="">
                            <div className="row mb-4">
                                <div className="col">
                                    {/* <h2 className="font-36 font-600 mb-0">Persona</h2> */}
                                </div>
                            </div>

                            <div className="row g-4">
                                <div className="col-lg-7">
                                    <div className="row g-4">
                                      {/* {<div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                            <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                            Not enough data to show the analytics
                                        </div>} */}
                                        <div className="col-md-7 position-relative">
                                          <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                              <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                              Not enough data to show the analytics
                                          </div>
                                            <div className="persona-grd d-flex align-items-end px-3 px-sm-3 px-md-3">
                                                <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/persona-17-24.svg" height='210px' alt=""/>
                                                <div className="persona-grd-text d-flex flex-column justify-content-center align-items-start h-100 ps-3">
                                                    {/* <h5 className="text-white mb-0">17 - 24</h5> */}
                                                    {/* <p className="text-white mb-0">Years Old</p> */}
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div className="col-md-5 position-relative">
                                            <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                                    Not enough data to show the analytics
                                                </div>
                                            <h5 className="font-20 font-600 d-flex align-items-center"><img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/user-img-h5.svg" className="me-2" width="25" alt=""/><span>Professional Identity</span></h5>
                                            <p>Oxford-educated luxury brand founder with legal roots, blending Indian heritage into global menswear, sustainable fashion leader, mentor, and media presence.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 ">
                                    
                                    <div className="row g-4 position-relative">
                                        <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                                    Not enough data to show the analytics
                                                </div>
                                        <div className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
                                            <div className="row g-3">
                                                <div className="col-auto"><img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-chat.svg" width="34" alt="" /></div>
                                                <div className="col">
                                                    <h3 className="font-18">Communication Style</h3>
                                                    <p className="text-gray-41 mb-0">Thoughtful and Purpose-Driven</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
                                            <div className="row g-3">
                                                <div className="col-auto"><img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-blub.svg" width="34" alt="" /></div>
                                                <div className="col">
                                                    <h3 className="font-18">Decision Factor</h3>
                                                    <p className="text-gray-41 mb-0">Sustainable Impact &amp; Business Value</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
                                            <div className="row g-3">
                                                <div className="col-auto"><img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-history.svg" width="34" alt="" /></div>
                                                <div className="col">
                                                    <h3 className="font-18">Peak Active Time</h3>
                                                    <p className="text-gray-41 mb-0">Business Hours, 9 AM-6 PM (IST)</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-md-6 col-sm-6">
                                            <div className="row g-3">
                                                <div className="col-auto"><img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/green-hook.svg" width="25" alt="" /></div>
                                                <div className="col">
                                                    <h3 className="font-18">Triggers &amp; Hooks</h3>
                                                    <p className="text-gray-41 mb-0">Manufacturing Innovation, Business Strategy,
                                                        Industrial Development</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 pt-4">
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <div className="shadow p-5 h-100 border-radius-6 position-relative">
                                                <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                                    Not enough data to show the analytics
                                                </div>
                                                <h3 className="font-30 font-600 mb-4">Engagement Prediction</h3>
                                                <div className="row g-4">
                                                    <div className="col-12">
                                                        <h4 className="font-20 font-600 mb-0 text-gray-c9">Donation Trigger</h4>
                                                        <p className="font-16 font-500 mb-1 text-gray-c9">High Alumni
                                                            Engagement &amp; Philanthropic</p>
                                                        <div className="progress mb-2 rounded-pill height-20 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "58%"}}></div>
                                                        </div>
                                                        <div className="row g-2">
                                                            <div className="col font-16 font-500 fst-italic text-gray-c9">
                                                                58% conversion probability</div>
                                                            <div className="col-auto"><a href="" className="text-gray-c9 font-500">12 More alumni</a></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <hr />
                                                    </div>
                                                    <div className="col-12">
                                                        <h4 className="font-20 font-600 mb-0 text-gray-c9">Recruitment
                                                            Trigger</h4>
                                                        <p className="font-16 font-500 mb-1 text-gray-c9">Industry Expertise
                                                            &amp; Business Leadership</p>
                                                        <div className="progress mb-2 rounded-pill height-20 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "52%"}}></div>
                                                        </div>
                                                        <div className="row g-2">
                                                            <div className="col font-16 font-500 fst-italic text-gray-c9">
                                                                52% conversion probability</div>
                                                            <div className="col-auto"><a href="" className="text-gray-c9 font-500">66 More alumni</a></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <hr />
                                                    </div>
                                                    <div className="col-12">
                                                        <h4 className="font-20 font-600 mb-0 text-gray-c9">Mentorship
                                                            Trigger</h4>
                                                        <p className="font-16 font-500 mb-1 text-gray-c9">Manufacturing
                                                            Experience &amp; Business Strategy</p>
                                                        <div className="progress mb-2 rounded-pill height-20 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "65%"}}></div>
                                                        </div>
                                                        <div className="row g-2">
                                                            <div className="col font-16 font-500 fst-italic text-gray-c9">
                                                                65% engagement probability</div>
                                                            <div className="col-auto"><a href="" className="text-gray-c9 font-500">79 More alumni</a></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="shadow p-5 h-100 border-radius-6 position-relative">
                                                <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                                    Not enough data to show the analytics
                                                </div>
                                                <h3 className="font-30 font-600 mb-4">Most Engaged Topics</h3>
                                                <div className="row g-3 ">
                                                    
                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">Investment Banking</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "25%"}}><b>25%</b></div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">Financial Markets</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={20} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "20%"}}><b>20%</b></div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">Wall Street Careers</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={18} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "18%"}}><b>18%</b></div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">Professional Development</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={15} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "15%"}}><b>15%</b></div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">MBA Programs</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={12} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "12%"}}><b>12%</b></div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <h4 className="font-18 font-600 mb-1 text-gray-c9">Corporate Finance</h4>
                                                        <div className="progress mb-2 rounded-pill height-28 bg-gray-ec" role="progressbar" aria-label="Basic example" aria-valuenow={10} aria-valuemin={0} aria-valuemax={100}>
                                                            <div className="progress-bar rounded-pill position-relative bg-gray-c9" style={{width: "10%"}}><b>10%</b></div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 pt-4">
                                    <div className="row justify-content-center">
                                        <div className="col-md-6 position-relative">
                                            <div className="notenoughdata position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center z-1 font-24 font-400 text-dark text-center bg-white bg-opacity-75 px-5">
                                                    <img src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-date-found-icon.svg" className="img-fluid" alt="No Data Found" />
                                                    Not enough data to show the analytics
                                                </div>
                                            <h5 className="d-flex justify-content-center align-items-center font-30 text-dark-blue">
                                                <img className="img-fluid me-2" src="./../images/green-time.svg" width="63" />Best Time To Reach
                                            </h5>
                                            <hr />
                                            <p className="text-gray-41 font-500 text-center">Monday and Wednesday, 10 AM-5
                                                PM (IST)</p>
                                            
                                        </div>
                                    </div>
                                </div>








                            </div>


                        </div>
                    </div>
        )}

        </div>
        </div>
  );
};

export default ProfileEngagement;
